import React, { Fragment, useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Collapse, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { ServiceThreadSpinner } from '.';
import { DesktopContainer } from '../layouts';
import { api, dateHelpers, helpers } from '../utils';

export default function OrdersOnHold(props) {
   const [activeOrder, setActiveOrder] = useState(null);
   const [heldOrders, setHeldOrders] = useState(null);
   const [loaded, setLoaded] = useState(false);
   const [working, setWorking] = useState(false);

   useEffect(() => {
      document.title = `Order Confirmation Hold`;
      if (!loaded) {
         api
            .fetch(`Order/ListHoldOrders`)
            .then(response => {
               if (response.data.success) {
                  setHeldOrders(response.data.orders);
               }
            })
            .catch(api.catchHandler)
            .finally(() => setLoaded(true));
      }
   }, [loaded])

   function clearOrder(orderId) {
      setWorking(true);
      toast.warning("Clearing order hold...")
      api
         .fetch(`Order/ClearOrderHold`, { OrderId: orderId })
         .then(response => {
         })
         .catch(api.catchHandler)
         .finally(() => {
            setWorking(false);
            setLoaded(false);
         })
   }

   function deleteOrder(orderId) {
      toast.warning("Deleting order...")
      setWorking(true)
      api
         .fetch(`Order/DeleteOrder`, { OrderId: orderId })
         .then(response => {
         })
         .catch(api.catchHandler)
         .finally(() => {
            setWorking(false);
            setLoaded(false);
         })
   }

   function sendOrderEmail(orderId, customerId) {
      setWorking(true);
      toast.warning("Sending confirmation email...")
      api
         .fetch(`Order/SendHeldOrderEmail`, { orderId: orderId, customerId: customerId })
         .then(response => {
            if (response.data.success) {
               toast.success("Email succesfully sent!");
            } else {
               if (_.isString(response?.data?.message)) {
                  toast.error(response?.data?.message);
               }
            }
         })
         .catch(api.catchHandler)
         .finally(() => {
            setWorking(false);
            setLoaded(false);
         })
   }

   function toggleActiveOrder(orderGroup) {
      if (activeOrder === orderGroup) {
         setActiveOrder(null);
      } else {
         setActiveOrder(orderGroup);
      }
   }

   return (
      <DesktopContainer screenName="Order Confirmation Hold">
         <ServiceThreadSpinner on={!loaded}>
            <Card>
               <CardHeader className='filter-header'>
                  <div style={{ paddingLeft: "1vw", color: "white" }}>
                     <span className="h2">Open Order on Confirmation Hold</span>
                  </div>
               </CardHeader>
               <CardBody className='pt-0'>
                  <hr />
                  {heldOrders && _.keys(heldOrders).length
                     ? (<Table size="sm" className="data-table w-75 m-auto">
                        <thead className="table-header">
                           <tr>
                              <th width="25%" children="Customer" />
                              <th width="10%" children="Order #" />
                              <th width="7%" children="Order Date" />
                              <th width="7%" children="Req Date" />
                              <th width="7%" children="Hold By" />
                              <th width="5%" children="Email" />
                              <th width="5%" children="Clear" />
                              <th width="5%" children="Delete" />
                           </tr>
                        </thead>
                        <tbody>
                           {_.map(heldOrders, (lines, orderGroup) => {
                              return (
                                 <Fragment key={`${orderGroup}`}>
                                    <tr className="table-header">
                                       <th
                                          className="shredLink data-cell"
                                          children={lines[0].customerDisplayName}
                                          onClick={() => toggleActiveOrder(orderGroup)}
                                       />
                                       <th className="data-cell" children={lines[0].orderId} />
                                       <th
                                          className="data-cell"
                                          children={dateHelpers.toLongDateString(lines[0].orderDate)}
                                       />
                                       <th
                                          className="data-cell"
                                          children={dateHelpers.toLongDateString(lines[0].requiredShipDate)}
                                       />
                                       <th className="data-cell" children={lines[0].holdBy} />
                                       <th>
                                          <Button
                                             className="shredButton"
                                             children="Send"
                                             onClick={() => sendOrderEmail(orderGroup, lines[0].customerId)}
                                             disabled={working}
                                          />
                                       </th>
                                       <th>
                                          <Button
                                             className="shredButton"
                                             children="Clear"
                                             onClick={() => clearOrder(orderGroup)}
                                             disabled={working}
                                          />
                                       </th>
                                       <th>
                                          <Button
                                             className="shredButton"
                                             children="Delete"
                                             onClick={() => deleteOrder(orderGroup)}
                                             disabled={working}
                                          />
                                       </th>
                                    </tr>
                                    <tr className="m-0 p-0">
                                       <td colSpan={5}>
                                          <Collapse isOpen={activeOrder === orderGroup}>
                                             <Table>
                                                <thead>
                                                   <tr>
                                                      <th children="Item" />
                                                      <th children="Unit Price" />
                                                      <th children="Extended Price" />
                                                   </tr>
                                                </thead>
                                                <tbody>
                                                   {_.map(lines, (line, index) => {
                                                      return (
                                                         <tr key={index}>
                                                            <td className="text-shredOrange" children={line.itemWithDesc} />
                                                            <td children={helpers.formatCurrency(line.unitPrice)} />
                                                            <td children={helpers.formatCurrency(line.extendedPrice)} />
                                                         </tr>
                                                      )
                                                   })}
                                                </tbody>
                                             </Table>
                                          </Collapse>
                                       </td>
                                       <td colSpan={3} />
                                    </tr>
                                 </Fragment>
                              )
                           })}
                        </tbody>
                     </Table>)
                     : <div className="h5 text-center">No hold orders found</div>
                  }
               </CardBody>
            </Card>
         </ServiceThreadSpinner>
      </DesktopContainer>
   );
}